export default __webpack_public_path__ + "static/media/casper.f861b35f.png";